import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'
import Rule from './Rule'

/* eslint-disable react/prop-types */
const renderRule = (values, active) => ({ label, checkValidity }) =>
  <Rule data-at-rule key={ label } label={ label } active={ active } isValid={ checkValidity(values) }>
    { label }
  </Rule>

const Rules = ({ rules = [], dirty, active = true, values = {}, ...props }) =>
  <RulesWrapper { ...props }>
    <RulesTitle data-at-rules-title>Password Requirements</RulesTitle>
    { rules.map(renderRule(values, active)) }
  </RulesWrapper>

Rules.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  isDirty: PropTypes.bool,
  rules: PropTypes.arrayOf(PropTypes.shape()),
  values: PropTypes.shape()
}

export default Rules


const RulesWrapper = styled.div`
  margin: ${props => props.margin || '30px 0 0'};
`
const RulesTitle = styled.p`
  margin: 0 0 7px;
  color: ${Theme.colors.dark_grey};
  ${Mixin.font.GothamBold(12)}
`
